<template>
    <base-card :add-margins="false" ref="headline">
        <template #card__title >
            <h2 class="accordion__title">{{ contact.request.person.name }}</h2>
        </template>
        <template #card__body >
            <section class="accordion">
                <base-form class="accordion__form"
                    :typeOfPreparation="'editCall'"
                >
                    <div class="accordion__aba">
                        <input type="radio" id="client" name="aba" class="accordion__input display--none" checked="true">
                        <label
                            for="client"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.personContactDetails') }}</label>
                        <div class="accordion__content accordion__content--default display--grid scroll accordion__content--dynamic">
                            <base-field
                                class="accordion__content__contact accordion__content__two"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.contactPerson') },
                                    input: {
                                        name: 'requestContact',
                                        value: contact.request.person.contactPerson,
                                    },
                                    allowFilling: false
                                }"
                            />
                            <base-field
                                class="accordion__content__tin"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.taxpayerIdentificationNumber') },
                                    input: {
                                        name: 'requestTaxpayerIdentificationNumber',
                                        value: contact.request.person.taxpayerIdentificationNumber,
                                    },
                                    allowFilling: false
                                }"
                            />
                            <base-field
                                class="accordion__content__nin"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.nationalIdentificationNumber') },
                                    input: {
                                        name: 'requestNationalIdentificationNumber',
                                        value: contact.request.person.nationalIdentificationNumber,
                                    },
                                    allowFilling: false
                                }"
                            />
                            <base-field
                                class="accordion__content__birthdate"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.birthdate') },
                                    input: {
                                        name: 'requestBirthdate',
                                        value: contact.request.person.birthdate,
                                    },
                                    allowFilling: false
                                }"
                            />
                            <div
                                class="accordion__content__contacts" v-for="( data, index ) in contactsArray" :key="index">
                                <base-field
                                    v-if="contact.request.person.contacts"
                                    class="accordion__content__contacts"
                                    :settings="{
                                        label: { class: 'capitalize', text: $t(`contacts.${ data.type }`)  },
                                        input: {
                                            name: 'contactOption',
                                            class: 'field__input--default typography--default color--default',
                                            value: data.value,
                                        },
                                        allowFilling: false
                                    }"
                                />
                            </div>
                            <base-field
                                class="contact__body__receptiondate"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.receptionDate') },
                                    input: {
                                        name: 'receptionDate',
                                        class: 'field__input--default typography--default color--default',
                                        value: parseUtcToLocalDate({
                                            date: contact.receptionDate,
                                            originFormat: 'DD-MM-YYYY HH:mm',
                                            finalFormat: 'DD-MM-YYYY HH:mm'
                                        }),
                                    },
                                    allowFilling: false
                                }"
                            />
                            <base-field
                                class="contact__body__preferencecontact"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.preferenceContact') },
                                    input: {
                                        name: 'preferenceContact',
                                        class: 'field__input--default typography--default color--default',
                                        value: parseUtcToLocalDate({
                                            date: contact.request.preferenceContact.date,
                                            originFormat: 'DD-MM-YYYY HH:mm',
                                            finalFormat: 'DD-MM-YYYY HH:mm'
                                        }),
                                    },
                                    allowFilling: false
                                }"
                            />
                            <base-field
                                v-if="contact.request.person.addresses"
                                class="accordion__content__address accordion__content__two"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.address') },
                                    input: {
                                        name: 'address',
                                        value: contact.request.person.addresses[0].address,
                                    },
                                    allowFilling: false
                                }"
                            />
                        </div>
                    </div>
                    <div class="accordion__aba">
                        <input type="radio" id="optional" name="aba" class="accordion__input display--none">
                        <label
                            for="optional"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.requestOptionalDetails') }}</label>
                        <dynamicFields
                            class="accordion__content accordion__content--small accordion__content--dynamic scroll"
                            :obj="contact.request.information.optional"
                        />
                    </div>
                    <div class="accordion__aba">
                        <input type="radio" id="request" name="aba" class="accordion__input display--none">
                        <label
                            for="request"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.requestDetails') }}</label>
                        <dynamicFields
                            class="accordion__content accordion__content--small accordion__content--dynamic scroll"
                            :obj="contact.request.information.data"
                        />
                    </div>
                    <div class="accordion__aba">
                        <input type="radio" id="requestObservations" name="aba" class="accordion__input display--none">
                        <label
                            for="requestObservations"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.requestObservations') }}</label>
                        <div class="accordion__content">
                            <base-field
                                class="accordion__content__fields"
                                :settings="{
                                    label: { class: 'field__label--hide', text: $t('global.requestObservations') },
                                    input: {
                                        name: 'requestObservations',
                                        disableClass: 'field__textarea--disable',
                                        value: contact.requestObservations,
                                    },
                                    allowFilling: false
                                }"
                            />
                        </div>
                    </div>
                    <div class="accordion__aba">
                        <input type="radio" id="internalObservations" name="aba" class="accordion__input display--none">
                        <label
                            for="internalObservations"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.internalObservations') }}</label>
                        <div class="accordion__content">
                            <base-field
                                :class="[
                                    'accordion__content__fields accordion__content__fields--textarea',
                                    { 'background--grey--light': allowFilling }
                                ]"
                                :settings="{
                                    label: { class: 'field__label--hide', text: $t('global.internalObservations') },
                                    input: {
                                        component: 'Textarea',
                                        name: 'internalObservations',
                                        id: 'internalObservations',
                                        class: 'accordion__content__fields__textarea typography--default color--default',
                                        value: contact.internalObservations,
                                        placeholder: $t('placeholders.observations')
                                    },
                                    isEdition: true,
                                    allowFilling: true,
                                    reset
                                }"
                            />
                        </div>
                    </div>
                    <div class="accordion__aba">
                        <input type="radio" id="callHistory" name="aba" class="accordion__input display--none">
                        <label
                            for="callHistory"
                            class="accordion__label position--relative display--block capitalize pointer"
                        >{{ $t('global.callHistory') }}</label>
                        <div class="accordion__content">
                            <base-table
                                class="accordion__content__fields"
                                :headers="[
                                    'beginDate',
                                    'operator',
                                    'state'
                                ]"
                                :list="calls"
                                model="history"
                                :settings="{
                                    component: 'RowCalls',
                                    warning: $t('global.calls'),
                                    removeMargin: true
                                }"
                            />
                        </div>
                    </div>
                </base-form>
            </section>
        </template>
    </base-card>
</template>

<script>
// TODO: optimizar estrutura HTML
// helpers
import { compareContacts } from '@/helpers/mixinContacts';

// packages
import { ref } from '@vue/composition-api';

// store
import { storePayload, useActions } from '@/hooks/use-store';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';

// utils
import { parseUtcToLocalDate } from '@/utils/';

export default {
    components: {
        ...singleStructure.components,
        BaseForm: () => import( /* webpackChunkName: 'BaseForm' */ '@/components/bundles/layout/forms/BaseForm' ),
        BaseCard: () => import( /* webpackChunkName: 'BaseCard' */ '@/components/bundles/cards/BaseCard' ),
        BaseField: () => import( /* webpackChunkName: 'BaseField'  */ '@/components/bundles/fields/BaseField' ),
        DynamicFields: () => import( /* webpackChunkName: 'DynamicFields' */ '@/components/bundles/layout/dynamicFields/DynamicFields' ),
        BaseTable: () => import( /* webpackChunkName: 'BaseTable' */ '@/components/bundles/tables/BaseTable' )
    },
    props: {
        ...singleStructure.props,
        contact: {
            type: Object,
            default: () => ({
                person: {},
                request: { person: {}, information: { data: {}, optional: {} } }
            })
        },
        allowFilling: {
            type: Boolean,
            default: true
        },
        isEdition: Boolean
    },
    setup ( props ) {
        const contactsArray = props.contact.request.person.contacts;
        const calls = ref( [] );
        contactsArray.sort( compareContacts );

        // obtenção dos dados das chamadas
        calls.value = props.contact.callHistory.map( call => ({
            ...call,
            beginDate: parseUtcToLocalDate({
                date: call.beginDate,
                originFormat: 'DD-MM-YYYY HH:mm:ss',
                finalFormat: 'DD-MM-YYYY HH:mm:ss'
            })
        }) );

        const { actions } = useActions();

        const structureData = newModel => {
            // se não exister novo model,
            // não é necessário executar o resto do código.
            if ( !Object.keys( newModel ).length )
                return;
            props.contact.internalObservations = newModel?.internalObservations;

            actions( 'saveHelper', { internalObservations: newModel?.internalObservations });
        };

        useData( props, structureData );

        const { reset } = storePayload();
        return {
            contactsArray,
            calls,
            reset,
            parseUtcToLocalDate
        };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $input-class: '.accordion__input';

    // =============================================================================
    // Style
    // =============================================================================
    .accordion {
        &__label {
            height: 50px;
            color: $color-grey-dark;
            line-height: 50px;
            border-bottom: 1px solid $color-black-light;
            padding: $card-spacing;
            @include transition( color .3s ease-in-out .1s );
            will-change: color;
            z-index: 1;
            &:hover {
                color: $color-green;
            }
            &::before {
                @include pseudo();
                left: 0;
                width: 0;
                height: 100%;
                background: $color-green;
                @include transition( width .2s ease-in-out );
                will-change: width;
                z-index: -1;
            }
            #{$input-class}:checked + & {
                color: $color-white;
                border-color: transparent;
                &::before {
                    width: 100%;
                }
                &:hover {
                    color: $color-white;
                }
            }
        }
        &__content {
            max-height: 0;
            padding: $card-spacing;
            opacity: 0;
            @include transform( translate( 0 , 50% ) );
            overflow: hidden;
            @include transition( all .3s ease-in-out );
            will-change: max-height, opacity, transform;
            &--default {
                grid-template-columns: repeat( auto-fit, minmax( 200px, 1fr ) );
            }
            &--small {
                grid-template-columns: repeat( auto-fit, minmax( 280px, 1fr ) );
            }
            &--dynamic {
                overflow-y: auto;
            }
            &__two {
                grid-column: 1 / 3;
            }
            &__fields {
                &--textarea {
                    @include rounded-corner( 19px );
                }
                &__textarea {
                    height: 300px;
                }
            }
            #{$input-class}:checked ~ & {
                max-height: 367px;
                padding: 30px 20px 30px 40px; // puxar o scroll para dentro
                margin-right: 20px;
                border-bottom: 1px solid $color-black-light;
                opacity: 1;
                @include transform( translate( 0 , 0 ) );
            }
        }
    }
</style>